// ensure correctly selected sorting option on page load
const currentParams = window.location.href.split("?")[1];
document.querySelectorAll('.collection-sorting option').forEach(option => {
    if (option.value.includes(currentParams)) {
        option.selected = true;
    }
})

// filter section
const filterSection = document.querySelector('.collectionFilter');

// filter selection, categories or tags
document.querySelectorAll('.collectionFilterSelectButton').forEach(button => {
    button.addEventListener('click', () => {
        // collect filter value and apply to filter section
        const filter = button.getAttribute('data-filter');
        // open mobile section
        filterSection.querySelector(`.collectionFilterSection[data-filter="${filter}"]`).classList.add('open');
        // remove active and show correct section - desktop
        if (button.classList.contains('active')) return;
        filterSection.querySelectorAll('.collectionFilterSelectButton.active').forEach(el => el.classList.remove('active'));
        filterSection.querySelectorAll('.collectionFilterSection.active').forEach(el => el.classList.remove('active'));
        filterSection.querySelectorAll(`[data-filter="${filter}"]`).forEach(el => el.classList.add('active'));
    });
});

// // filter collection items by tags
// document.querySelectorAll('.collectionFilterItem').forEach(item => {
//     // get tag for compare and add event listener
//     const tag = item.querySelector('.collectionFilterItemTitle').textContent.toLowerCase();
//     item.addEventListener('click', () => {
//         if (item.classList.contains('active')) {
//             item.classList.remove('active');
//             tagFilters = tagFilters.filter(filter => filter !== tag);
//         } else {
//             item.classList.add('active');
//             tagFilters.push(tag);
//         }
//         filterCollectionItems();
//     })
// });
//
// // keep track of added filters
// let tagFilters = [];
//
// // filter collection items by tags
// function filterCollectionItems() {
//     if (tagFilters.length === 0) {
//         document.querySelectorAll('.collectionItem').forEach(item => item.style.display = 'flex');
//         return;
//     }
//     // compare list of product tags against the group of selected collection tags
//     document.querySelectorAll('.collectionItem').forEach(item => {
//         const tags = item.getAttribute('data-tags').toLowerCase();
//         const hasTags = tagFilters.every(tag => tags.includes(tag));
//         item.style.display = hasTags ? 'flex' : 'none';
//     });
// }

// mobile filters
document.querySelector('.collectionSortingButton').addEventListener('click', () => {
    filterSection.querySelector(`.collectionFilterSection[data-filter="sortBy"]`).classList.add('open');
});

filterSection.querySelectorAll('.collectionFilterItemClose').forEach(el => {
    el.addEventListener('click', () => {
        el.parentElement.classList.remove('open');
    });
})

filterSection.querySelector('.collectionFilterBackground').addEventListener('click', () => {
    filterSection.querySelectorAll('.collectionFilterSection').forEach(el => el.classList.remove('open'));
})

